<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div>
          <template>
            <v-card>
              <div class="d-flex">
                <v-btn color="#00004d" dark class="ml-auto ma-3 mr-1" @click="refreshData">
                  <i style="color: #fff" class="flaticon2-refresh-1"></i>
                </v-btn>
              </div>
              <hr style="margin:0"/>
              <v-card-title>
                NOC Requests ({{ addTSBVZ(totalRecords) }})
              </v-card-title>
              <v-skeleton-loader :loading="loading" v-if="isLoaded" type="table"
              >
              </v-skeleton-loader>
              <v-data-table
                  :headers="headers"
                  :items="items"
                  :show-expand="canViewNocForm"
                  :options.sync="pagination"
                  :server-items-length="totalRecords"
                  :footer-props="{
                    itemsPerPageOptions: rowsPerPageItems,
                    showFirstLastPage: true,
                  }"
                  :loading="loading"
                  v-show="!isLoaded"
                  mobile-breakpoint="100"
                  class="elevation-0">
                <template v-slot:[`item.user.name`]="{ item }">
                  <div class="text-truncate">
                    {{ item.user ? item.user.name + (item.user.email ? ' (' + item.user.email + ')' : '') : '-' }}
                  </div>
                </template>
                <template v-slot:item.is_approved="{ item }">
                  <v-switch
                      v-if="$store.state.auth.user.type === 2 || ($store.state.auth.user.type === 4 && $store.state.auth.user.can_approve_noc === 1)"
                      v-model="item.is_approved"
                      v-bind:color="item.is_approved === 1 ? 'success': ''"
                      item-value="value"
                      @change="updateStatus($event, 'is_approved', item.id)"
                  ></v-switch>
                  <div class="text-truncate" v-else>
                    {{ item.is_approved === 1 ? 'Approved' : 'Not Approved' }}
                  </div>
                </template>
                <template v-slot:item.is_authorized="{ item }">
                  <v-switch
                      v-if="$store.state.auth.user.type === 2 || ($store.state.auth.user.type === 4 && $store.state.auth.user.can_authorize_noc === 1)"
                      v-model="item.is_authorized"
                      v-bind:color="item.is_authorized === 1 ? 'success': ''"
                      item-value="value"
                      @change="updateStatus($event, 'is_authorized', item.id)"
                  ></v-switch>
                  <div class="text-truncate" v-else>
                    {{ item.is_authorized === 1 ? 'Authorized' : 'Not Authorized' }}
                  </div>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <div class="text-truncate">
                    {{ formatDateAndTime(item.created_at) }}
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- TEMP: restore developerPdfAssetsReady(item) after verification -->
                  <v-btn
                      v-if="canViewNocForm"
                      @click="openNocFormPdf(item)"
                      dark
                      color="info"
                      small
                  >
                    <template v-if="nocPdfLoadingId === item.id">
                      <v-progress-circular indeterminate size="16" width="2" color="white" class="mr-2"></v-progress-circular>
                      Loading...
                    </template>
                    <template v-else>
                      View NOC
                    </template>
                  </v-btn>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" v-if="item.user">
                    <v-row>
                      <v-col cols="12">
                        <v-card
                            class="mx-auto"
                            outlined
                            rounded
                        >
                          <v-card-text class="pt-0 pb-0">
                            <v-row>
                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Name</h6>
                                  <p>{{ item.user.name ? item.user.name : 'N/A' }}</p>
                                </div>
                                <div>
                                  <h6>Email</h6>
                                  <p>{{ item.user.email ? item.user.email : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Phone</h6>
                                  <p>{{ item.user.number ? item.user.number : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Project(s)</h6>
                                  <div>
                                    <p v-for="(project, ind) in item.user.developer_agency_projects" :key="ind">{{ project.project ? project.project.title : '' }}</p>
                                  </div>
                                </div>
                                <div>
                                  <h6>Address</h6>
                                  <p>{{ item.user.address ? item.user.address : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Copy of Visa</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.user.visa_file)">{{ item.user.visa_file ? 'View' : '-' }}</a></p>
                                </div>
                              </v-col>

                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Trade License Number</h6>
                                  <p>{{ item.user.trade_license_number ? item.user.trade_license_number : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Trade License Issue Date</h6>
                                  <p>{{ item.user.tln_issue_date ? item.user.tln_issue_date : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Trade License Expiry Date</h6>
                                  <p>{{ item.user.tln_expiry_date ? item.user.tln_expiry_date : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Trade License</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.user.tln_file)">{{ item.user.tln_file ? 'View' : '-' }}</a></p>
                                </div>
                                <div>
                                  <h6>Tax Registration Number</h6>
                                  <p>{{ item.user.trn ? item.user.trn : '-' }}</p>
                                </div>
                              </v-col>

                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Tax Registration Certificate</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.user.trn_file)">{{ item.user.trn_file ? 'View' : '-' }}</a></p>
                                </div>

                                <div>
                                  <h6>Organization Registration Number</h6>
                                  <p>{{ item.user.organization_registration_number ? item.user.organization_registration_number : '-' }}</p>
                                </div>

                                <div>
                                  <h6>Organization Registration Certificate</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.user.orn_file)">{{ item.user.orn_file ? 'View' : '-' }}</a></p>
                                </div>

                                <div>
                                  <h6>Memorandum Of Agreement (MOA)</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.user.moa_file)">{{ item.user.moa_file ? 'View' : '-' }}</a></p>
                                </div>
                                <div>
                                  <h6>Bank Title</h6>
                                  <p>{{ item.user.bank_title ? item.user.bank_title : '-' }}</p>
                                </div>
                              </v-col>

                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Bank IBAN</h6>
                                  <p>{{ item.user.bank_iban ? item.user.bank_iban : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Bank Name</h6>
                                  <p>{{ item.user.bank_name ? item.user.bank_name : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Other Bank Name</h6>
                                  <p>{{ item.user.other_bank_name ? item.user.other_bank_name : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Bank Branch</h6>
                                  <p>{{ item.user.bank_branch ? item.user.bank_branch : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Bank Swift Code</h6>
                                  <p>{{ item.user.bank_swift ? item.user.bank_swift : '-' }}</p>
                                </div>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="12">
                                <h3>Owners Details:</h3><br>
                                <div class="bg-white">
                                  <v-simple-table dense>
                                    <template v-slot:default>
                                      <thead>
                                      <tr>
                                        <th class="text-left">
                                          Emirates ID Number
                                        </th>
                                        <th class="text-left">
                                          Passport Number
                                        </th>
                                        <th class="text-left">
                                          Emirates ID
                                        </th>
                                        <th class="text-left">
                                          Passport Copy
                                        </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr
                                          v-for="(owner, i) in item.agency_owners"
                                          :key="i"
                                      >
                                        <td>{{ owner.owner_emirates_id }}</td>
                                        <td>{{ owner.owner_passport_number }}</td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(owner.owner_emirates_id_file)">{{ owner.owner_emirates_id_file ? 'View' : '-' }}</a>
                                        </td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(owner.owner_passport_file)">{{ owner.owner_passport_file ? 'View' : '-' }}</a>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </div>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="12">
                                <h3>Brokers Details:</h3><br>
                                <div class="bg-white">
                                  <v-simple-table dense>
                                    <template v-slot:default>
                                      <thead>
                                      <tr>
                                        <th class="text-left">
                                          Name
                                        </th>
                                        <th class="text-left">
                                          Contact Number
                                        </th>
                                        <th class="text-left">
                                          Email
                                        </th>
                                        <th class="text-left">
                                          Broker Registration Number
                                        </th>
                                        <th class="text-left">
                                          Passport Copy
                                        </th>
                                        <th class="text-left">
                                          Emirates ID
                                        </th>
                                        <th class="text-left">
                                          Broker ID
                                        </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr
                                          v-for="(broker, i) in item.agency_brokers"
                                          :key="i"
                                      >
                                        <td>{{ broker.name }}</td>
                                        <td>{{ broker.country_code ? '+' + broker.country_code + broker.number : broker.number }}</td>
                                        <td>{{ broker.email }}</td>
                                        <td>{{ broker.brn }}</td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(broker.passport_copy)">{{ broker.passport_copy ? 'View' : '-' }}</a>
                                        </td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(broker.emirates_id)">{{ broker.emirates_id ? 'View' : '-' }}</a>
                                        </td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(broker.broker_id)">{{ broker.broker_id ? 'View' : '-' }}</a>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </td>
                </template>
              </v-data-table>
              <!-- this dialog is used for both create and update -->
            </v-card>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Vue from "vue";
import ApiService from "@/core/services/api.service";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {SET_CONFIRMATION} from "@/core/services/store/confirmation.module";
import {REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module";
import {SET_SNACK} from "@/core/services/store/snackbar.module";
import {
  CLEAR_USER_ERRORS,
  DELETE_NOC,
  NOCES_LIST, UPDATE_NOC_STATUS
} from "@/core/services/store/users.module";
import {PROJECTS_SIMPLE_LIST} from "@/core/services/store/projects.module";
import {buildFileUrl} from "@/utils/fileUrl";
import Swal from "sweetalert2";

export default {
  name: 'noc',
  data() {
    return {
      headers: [
        {text: 'Agency Name', value: 'user.name', name: 'user.name', filterable: false, sortable: true},
        {text: 'Project', value: 'project.title', name: 'project.title', filterable: false, sortable: false},
        {text: 'Approved', value: 'is_approved', name: 'is_approved', filterable: false, sortable: false},
        {text: 'Approved By', value: 'approved_by_user.name', name: 'approved_by_user', filterable: false, sortable: false},
        {text: 'Authorized', value: 'is_authorized', name: 'is_authorized', filterable: false, sortable: false},
        {text: 'Authorized By', value: 'authorized_by_user.name', name: 'authorized_by_user', filterable: false, sortable: false},
        {text: "Requested At", value: "created_at", name: "created_at", filterable: true, sortable: true},
        {text: "Actions", value: "actions", name: "actions", filterable: false, sortable: false},
      ],
      isLoaded: true,
      draw: 1,
      searchQuery: "",
      loading: true,
      nocPdfLoadingId: null,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
        sortDesc: "desc"
      },
      totalRecords: 0,
      rowsPerPageItems: [25, 50, 100, 150, 200],
      headerindex: "",
      columns: [],
      validationRules: {
        valid: true,
        titleRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than 3 characters",
          v => (v && v.length <= 50) || "Must be less than 50 characters"
        ],
        selectRules: [
          v => !!v || "This field is required"
        ],
      },
      items: [],
      agencyFilter: [],
      projectsFilter: [],
      isProjectsLoaded: false,
      dialog: false,
      editedItem: {}
    }
  },
  watch: {
    params: {
      handler() {
        this.loadData().then(response => {
          this.items = response.items;
          this.totalRecords = response.total;
        });
      },
      deep: true
    },
  },
  mounted() {
    for (let i = 0; i < this.headers.length; i++) {
      this.columns.push(
          '&columns[' + i + '][data]=' + this.headers[i].value +
          '&columns[' + i + '][name]=' + this.headers[i].name +
          '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
          '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
          '&columns[' + i + '][search][value]=' +
          '&columns[' + i + '][search][regex]=' + false
      );
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Setup", route: "brands"},
      {title: "Brands"}
    ]);
    if (this.$route.query.hasOwnProperty('addModule')) {
      this.dialog = true;
    }
  },
  methods: {
    buildFileUrl,
    refreshData() {
      this.loadData().then(response => {
        this.items = response.items;
        this.totalRecords = response.total;
      });
    },
    searchQueryData: function (e) {
      if (e.keyCode === 13) {
        this.searchQuery = e.target.value;
      }
    },
    getHeaderIndex(name) {
      let that = this;
      this.headers.filter(function (ele, i) {
        if (name == ele.name) {
          that.headerindex = i;
        }
      });
    },
    loadData() {
      this.loading = true;
      this.isLoaded = true;
      return new Promise((resolve) => {
        let params = this.params;
        params.length = params.itemsPerPage; //set how many records to fetch per page
        params.start =
            params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
        params.draw = this.draw;
        let query = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
        this.getHeaderIndex(params.sortBy[0]);
        query +=
            "&search[value]=" +
            params.query +
            "&search[regex]=" +
            false +
            "&order[0][column]=" +
            (params.sortBy.length === 0 ? 6 : this.headerindex) +
            "&order[0][dir]=" +
            (params.sortDesc[0] ? "desc" : "asc");
        this.$store.dispatch(NOCES_LIST, {q: query, columns: this.columns}).then((res) => {
          this.draw++;
          let items = res.records.data;
          let total = res.records.recordsFiltered;
          this.loading = !this.loading;
          this.isLoaded = !this.isLoaded;
          resolve({
            items,
            total
          });
        });
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    closeDialog() {
      this.dialog = !this.dialog;
    },
    deleteItem(item) {
      let that = this;
      this.$store.dispatch(SET_CONFIRMATION, {
        title: "Are you sure?", msg: "You want to delete?", clr: 'red', callback: function () {
          let id = item.id;
          this.$store.dispatch(DELETE_NOC, {
            'noc_id': id
          }).then(() => {
            that.loadData().then(response => {
              that.items = response.items;
              that.totalRecords = response.total;
            });
          });
        }
      });
    },
    projectsFilterKeyUp(e) {
      clearTimeout(this.apiTimeout)
      let that = this
      this.apiTimeout = setTimeout(function () {
        if (e.target.value.length >= 3) {
          that.isProjectsLoaded = true;
          that.$store
              .dispatch(PROJECTS_SIMPLE_LIST, {
                q: e.target.value,
                type: 'none'
              })
              .then(data => {
                that.projectsFilter = data.records.projectsList;
                that.isProjectsLoaded = false;
              });
        }
      }, 900);
    },
    updateStatus(status, column, cId) {
      if (this.$store.state.auth.user.signature_url && this.$store.state.auth.user.stamp_url) {
        this.$store.dispatch(CLEAR_USER_ERRORS);
        let data = {
          status: status,
          column: column
        };
        this.$store.dispatch(UPDATE_NOC_STATUS, {'slug': cId, data: data}).then(() => {
          this.loadData().then(response => {
            this.items = response.items;
            this.totalRecords = response.total;
          });
        })
      } else {
        Swal.fire('Signature and Stamp required!', 'Please update your signature and stamp in settings.', 'error')
            .then(() => {
              this.$router.push("settings");
            })
      }
    },
    openNocFormPdf(item) {
      if (!item || !item.id) {
        return;
      }

      if (this.nocPdfLoadingId === item.id) {
        return;
      }

      this.nocPdfLoadingId = item.id;

      ApiService.setHeader();
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
      Vue.axios
          .get(`api/nocformpdf/${item.id}/share`)
          .then((response) => {
            const data = response.data || {};
            if (!data._metadata || data._metadata.outcomeCode !== 0) {
              const message = data._metadata && data._metadata.message
                  ? data._metadata.message
                  : 'Unable to generate NOC form PDF.';
              this.$store.dispatch(SET_SNACK, {clr: 'error', msg: message});
              return;
            }

            const token = data.records && data.records.token;
            if (!token) {
              this.$store.dispatch(SET_SNACK, {clr: 'error', msg: 'Unable to generate NOC form PDF.'});
              return;
            }

            const url = `${window.location.origin}/noc-form/${token}`;
            window.open(url, '_blank');
          })
          .catch(() => {
            this.$store.dispatch(SET_SNACK, {clr: 'error', msg: 'Unable to generate NOC form PDF.'});
          })
          .finally(() => {
            this.nocPdfLoadingId = null;
          });
    },
    developerPdfAssetsReady(item) {
      // TEMP: PDF branding check disabled for NOC testing — restore after verification
      return true;
      // if (item && Object.prototype.hasOwnProperty.call(item, 'developer_pdf_assets_ready')) {
      //   return !!item.developer_pdf_assets_ready;
      // }
      //
      // return !!this.$store.state.auth.user.pdf_assets_ready;
    }
  },
  computed: {
    canViewNocForm() {
      const type = this.$store.state.auth.user.type;
      // 2 = developer, 4 = agent (developer sub-user)
      return type === 2 || type === 4;
    },
    params() {
      return {
        ...this.pagination,
        query: this.searchQuery
      };
    },
    ...mapState({
      errors: state => state.users.errors
    })
  }
};
</script>